<svg
  width="32"
  height="32"
  viewBox="0 0 32 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M13.3333 29.3334V20.5734"
    stroke="#1F4321"
    stroke-width="2.66667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M16 14.6666H16.0133"
    stroke="#1F4321"
    stroke-width="2.66667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M16 9.33337H16.0133"
    stroke="#1F4321"
    stroke-width="2.66667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M18.6667 20.5734V29.3334"
    stroke="#1F4321"
    stroke-width="2.66667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M20 21.3333C18.846 20.4679 17.4425 20 16 20C14.5575 20 13.154 20.4679 12 21.3333"
    stroke="#1F4321"
    stroke-width="2.66667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M21.3333 14.6666H21.3466"
    stroke="#1F4321"
    stroke-width="2.66667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M21.3333 9.33337H21.3466"
    stroke="#1F4321"
    stroke-width="2.66667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M10.6667 14.6666H10.68"
    stroke="#1F4321"
    stroke-width="2.66667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M10.6667 9.33337H10.68"
    stroke="#1F4321"
    stroke-width="2.66667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M24 2.66663H7.99998C6.52722 2.66663 5.33331 3.86053 5.33331 5.33329V26.6666C5.33331 28.1394 6.52722 29.3333 7.99998 29.3333H24C25.4727 29.3333 26.6666 28.1394 26.6666 26.6666V5.33329C26.6666 3.86053 25.4727 2.66663 24 2.66663Z"
    stroke="#1F4321"
    stroke-width="2.66667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
